import { isTrialPromotionConfiguration, isCreditPromotionConfiguration, isPercentagePromotionConfiguration } from '@weft/services';
import type { PromotionConfiguration, PromotionType } from '@weft/types';

export function getPromotionConfigDefaultValue(promotionConfig: PromotionConfiguration, promotionType: PromotionType) {
  if (isTrialPromotionConfiguration(promotionType, promotionConfig)) {
    return promotionConfig.daysFree;
  }
  
  if (isCreditPromotionConfiguration(promotionType, promotionConfig)) {
    return promotionConfig.creditAmount;
  }

  if (isPercentagePromotionConfiguration(promotionType, promotionConfig)) {
    return promotionConfig.percentage;
  }
  
  throw new Error(`Invalid promotion type ${promotionType}`);
}